export default "__VITE_ASSET__pfiYcxn6__"